<template>
<div class="tongxingzheng_bg" ref="faultTree">
  <div class="container" id="table">
    <div class="title">
      <p>问题报告</p>
      <p style="padding-left:3%;">{{report.startTime}}——{{report.endTime}}</p>
      <el-button @click="printContent()" class="export">下载</el-button>
    </div>
    <div class="content">
      <span v-for="(item,indexa) in zoneLists" :key="indexa" @click="partition(indexa)" :class="index==indexa?'isActive':''">分区{{item.zoneid}}</span>
      <!-- <span @click="partition(1)" :class="index=='1'?'isActive':''">分区二</span> -->
      <br><br><br>
      <div class="">
        <p class="font_fam_content"><span class="font_fam">01</span><span style="vertical-align:top;">&ensp;理想状态</span></p>
        <ul class="lixiang_type">
          <li><span>Block打包总数量</span>{{report.theoryBlockingNum}}</li>
          <li><span>Block单个打包时间</span>{{report.theoryBlockingTime}}</li>
          <li><span>单笔交易上链时间</span>{{report.theoryOnchainTime}}</li>
          <li><span>交易上链总数量</span>{{report.theoryOnchainNum}}</li>
          <li><span>Block单个交易数量</span>{{report.theoryOutNum}}</li>
          <li><span>交易上链的总时间</span>{{report.theoryOnchainAllTime}}</li>
        </ul>
        <p style="font-size:18px;color:#060606;margin:15px 0 30px 0;">web交易处理时间及路径</p>
        <div class="">
          <div class="process">
            <span class="process_span">web</span>
            <span class="process_top">{{report.theoryWebDealWithTime}}ms</span>
            <span class="process_bottom">{{report.theoryWebDealWithTime}}ms</span>
            <p class="process_one">
              <span class="jiantou" style="display:block;"></span>
              <span class="jiantou2"></span>
              <span class="process_three">{{report.theoryWebSendTime}}ms</span>
              <span class="process_four">{{report.theoryWebEchoTime}}ms</span>
            </p>
          </div>
          <div class="process">
            <span class="process_span">wallet</span>
            <span class="process_top">{{report.theoryWalletDealWithTime}}ms</span>
            <span class="process_bottom">{{report.theoryWalletDealWithTime}}ms</span>
            <p class="process_one">
              <span class="jiantou" style="display:block;"></span>
              <span class="jiantou2"></span>
              <span class="process_three">{{report.theoryWalletSendTime}}ms</span>
              <span class="process_four">{{report.theoryWalletEchoTime}}ms</span>
            </p>
          </div>
          <div class="process">
            <span class="process_span">node</span>
            <span class="process_top">{{report.theoryNodeDealWithTime}}ms</span>
            <span class="process_bottom">{{report.theoryNodeDealWithTime}}ms</span>
            <p class="process_one">
              <span class="jiantou" style="display:block;"></span>
              <span class="jiantou2"></span>
              <span class="process_three">{{report.theoryNodeSendTime}}ms</span>
              <span class="process_four">{{report.theoryNodeEchoTime}}ms</span>
            </p>
          </div>
          <div class="process">
            <span class="process_span">center</span>
            <span class="process_top">{{report.theoryCenterDealWithTime}}ms</span>
            <span class="process_bottom">{{report.theoryCenterDealWithTime}}ms</span>
          </div>
          <div class="type_lie">
            <p>
              <span class="yuan1"></span><span>&ensp;发出交易时间</span>
              <br>
              <span class="yuan2"></span><span>&ensp;返回交易时间</span>
            </p>
          </div>
        </div>
        <br><br><br>
        <p class="font_fam_content"><span class="font_fam">01</span>
          <span style="vertical-align:top;">&ensp;实际运行状态</span>
          <span @click="divShow1">
            <i class="el-icon-question"></i>
          </span>
        </p>
        <div class="divHide1" style="background-color:#ededed;width:98%;height:auto;display:none;padding: 10px;">
            1.block打包总数量：统计某个时间段内，特定分区内的block个数。（分区表）<br/>
            2.block空包数量：空包的概念，block中的vTx长度为1，并且vout长度为1，vin的长度也为1.（block表）<br/>
            3.交易未上链总数：查询指令字buildCoinBaseTx的所有packet,并根据其中的traceId，查询指令字为sendUtxo的packet，如果有，表示此次交易未上链。（neo4j）<br/>
            4.交易上链总数量：统计某个时间段内，transaction表中，如果vTxOut的个数不等于1时，统计payload的总数。（transaction表）<br/>
            5.tps:计算公式：（交易上链总数量*最大out数）/（结束时间-开始时间）。<br/>
            6.交易上链总时间：查询指令字buildCoinBaseTx的所有packet，对于每一个packet,得到updateTime；然后利用此packet的traceId，查找指令字为sendUtxo的packet,得到updateTime，最后获得这两个时间差。<br/>
            7.满包率：满包个数/block打包总数量，其中满包概念：block里面的vTx个数为30，并且每个vTx中vout和vin的和大于等于10.<br/>
            8.空包率：（空包个数/block打包总数量）<br/>
            9.满载率：（此分区的block打包个数）/1分区的block个数。<br/>
            10.最大高度：某时间段内，此分区的最大block高度。<br/>
            11.最小高度：某时间内，此分区的最小block高度。<br/>
        </div>
        <ul class="lixiang_type">
          <li><span>Block打包总数量</span>{{report.blockingNum}}</li>
          <li><span>Block空包数量</span>{{report.blankBlockNum}}</li>
          <li><span>交易未上链总数</span>{{report.notOnchainNum}}</li>
          <li><span>交易上链总数量</span>{{report.onchainNum}}</li>
          <li><span>TPS</span>{{report.tps}}/s</li>
          <li><span>交易上链的总时间</span>{{report.onchainAllTime}}</li>
          <!-- <li><span>Block打包总数量</span>{{report.blockingNum}}</li>
          <li><span>Block空包数量</span>{{report.blankBlockNum}}</li>
          <li><span>交易未上链总数</span>{{report.notOnchainNum}}</li> 
          <li><span>交易上链总数量</span>{{report.onchainNum}}</li>
          <li><span>TPS</span>{{report.tps}}/s</li>
          <li><span>交易上链的总时间</span>{{report.onchainAllTime}}</li> -->
        </ul>
        <ul class="lixiang_type">
          <li><span>满包率</span>{{report.fullBlockRate}}%</li>
          <li><span>空包率</span>{{report.emptyBlockRate}}%</li>
          <li><span>满载率</span>{{report.fullLoad}}%</li>
          <li><span>最大高度</span>{{report.maxHeight}}</li>
          <li style="width:66.66%;"><span>最小高度</span>{{report.minHeight}}</li>
          <!-- <li><span>满包率</span>{{report.fullBlockRate}}%</li>
          <li><span>空包率</span>{{report.emptyBlockRate}}%</li>
          <li><span>满载率</span>{{report.fullLoad}}%</li>
          <li><span>最大高度</span>{{report.maxHeight}}</li>
          <li style="width:75%;"><span>最小高度</span>{{report.minHeight}}</li> -->
        </ul>
        <div class="unit_echarts">
            <p style="z-index:999;cursor:pointer;"><span></span>&ensp;单个Block打包时间
              <i class="el-icon-question" @click="divShowPic1"></i>
            </p><br/><br/>
            <div class="divHidePic1" style="background-color:#ededed;width:98%;height:auto;display:none;padding: 10px;width: 20%;margin:10px;float:right;">
            单个block打包时间：查询某个时间段内，查询关键字为“doStepT01 is done. and total time is”的日志信息，从中得到打包时间，（单位是毫秒）。（logs）<br/>
            </div>
            <!-- <p @click="divShowPic1"> -->
              
            <!-- </p> -->
          <div id="haderPaint">

          </div>
        </div>
        <div class="unit_echarts">
          <p style="z-index:999;cursor:pointer;"><span style="background:#009896;"></span>&ensp;单个Block包含交易的数量
            <i class="el-icon-question" @click="divShowPic2"></i>
          </p><br/><br/>
          <div class="divHidePic2" style="background-color:#ededed;width:98%;height:auto;display:none;padding: 10px;width: 20%;margin:10px;float:right;">
          单个block包含的交易的数量：在某个时间段内，过滤掉空包信息，计算每个block中vTx的长度大小。（分区表）<br/>
          </div>
          <!-- <span><span style="background:#009896;"></span>&ensp;单个Block包含交易的数量</!--> 
          <div id="haderPaint2">

          </div>
        </div>
        <span style="font-size:18px;color:#060606">各节点之间的通信包数量</span>
        <span @click="divShow2">
          <i class="el-icon-question"></i>
        </span>
        <div class="divHide2" style="background-color:#ededed;width:98%;height:auto;display:none;padding: 10px;">
            （1）web---->wallet:在某个时间段内，计算指令字为buildCoinBaseTx，sendType不等于echoPacket的packet的个数，并除以2。（neo4j）<br/>
            （2）wallet----->node:在某个时间段，计算指令字为issueCoinBase，sendType不等于echoPacket的packet的个数，并除以2.(neo4j)<br/>
            （3）node----->center:在某个时间段，计算指令字为reportBlock，sendType不等于echoPacket的packet的个数，并除以2.(neo4j).<br/>
            （4）node---->wallet:在某个时间段内，计算指令字为sysnUTXO,sendType不等于echoPacket的packet的个数，并除以2.(neo4j)<br/>
            （5）wallet----->web：在某个时间段内，计算指令字sendUtxo，sendType不等于echoPacket的packet的个数，并除以2.（neo4j）<br/>
        </div>
        <!-- <ul class="lixiang_type_num">
            <li><span class="web_cell_a"></span>&nbsp;<span class="web_cell">web</span><span class="jiantou3"></span>&ensp;&nbsp;wallet</li>
            <li><span class="web_cell_b"></span>&nbsp;<span class="web_cell">wallet</span><span class="jiantou3"></span>&ensp;&nbsp;node</li>
            <li><span class="web_cell_c"></span>&nbsp;<span class="web_cell">node</span><span class="jiantou3"></span>&ensp;&nbsp;center</li>
            <li><span class="web_cell_d"></span>&nbsp;<span class="web_cell">web</span><span class="jiantou4"></span>&ensp;&nbsp;wallet</li>
            <li  style="width: 75%;"><span class="web_cell_e"></span>&nbsp;<span class="web_cell">wallet</span><span class="jiantou4"></span>&ensp;&nbsp;node</li>
        </ul> -->
        <div class="unit_echarts">
          <div id="haderPaint3">

          </div>
        </div>
        <span style="font-size:18px;color:#060606">web交易处理时间及路径</span>
        <span @click="divShow3">
          <i class="el-icon-question"></i>
        </span>
        <div class="divHide3" style="background-color:#ededed;width:98%;height:auto;display:none;padding: 10px;">
          （1）web--->wallet通信时间：在某个时间段内，查询指令字buildCoinBaseTx的packet，对于每个packet1，得到traceId，并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，从中选择最大值和最小值。<br/>
          （2）wallet---->node通信时间：在某个时间段内，查询指令字issueCoinBase的packet,对于每个pakcet1，得到tracedId,并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，从中选择最大值和最小值。<br/>
          （3）node----->center：在某个时间段内，查询指令字reportBlock的packet,对于每个pakcet1，得到tracedId,并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，从中选择最大值和最小值.<br/>
          （4）center----->node：在某个时间段，查询指令字getCurrStamp，对于每个pakcet1，得到tracedId,并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，从中选择最大值和最小值.<br/>
          （5）node---->wallet:在某个时间段内，查询指令字sysnUTXO，对于每个pakcet1，得到tracedId,并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，从中选择最大值和最小值.<br/>
          （6）wallet---->web：在某个时间段内，查询指令字sendUtxo,对于每个pakcet1，得到tracedId,并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，从中选择最大值和最小值.<br/>
          （7）wallet处理时间（正向）：在某个时间段内，查询指令字为buildCoinBaseTx的packet,对于每个packet1，得到traceId，并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，计算平均值。<br/>
          （8）node处理时间（正向）：在某个时间段内，查询指令字为issueCoinBase的packet，对于每个packet1，得到traceId，并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，计算平均值。<br/>
          （9）center处理时间（正向）：在某个时间段内，查询指令字为reportBlock的packet，对于每个packet1，得到traceId，并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，计算平均值。<br/>
          （10）center处理时间（反向）：在某个时间段内，查询指令字为getCurrStamp的packet，对于每个packet1，得到traceId，并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，计算平均值。<br/>
          （11）node处理时间（反向）：在某个时间段内，查询指令字为sysnUTXO的packet，对于每个packet1，得到traceId，并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，计算平均值。<br/>
          （12）wallet处理时间（反向）：在某个时间段内，查询指令字为sendUtxo的packet，对于每个packet1，得到traceId，并根据traceId查询相应的packet2，如果查询的packet2和packet1不一样，就计算这两个packet之间的uptime时间差，计算平均值。<br/>
        </div>
        <br><br>

        <div class="process">
          <span class="process_span">web</span>
          <!-- <el-tooltip placement="top-start">
            <div slot="content">多行信息<br/>第二行信息</div>
            <span class="process_top">{{report.webDealWithTimeFor}}ms</span>
          </el-tooltip>
           <el-tooltip placement="bottom-start">
            <div slot="content">多行信息<br/>第二行信息</div>
            <span class="process_bottom">{{report.webDealWithTimeRev}}ms</span>
          </el-tooltip> -->
          <!-- <span class="process_top">{{report.webDealWithTimeFor}}ms</span>
          <span class="process_bottom">{{report.webDealWithTimeRev}}ms</span> -->
          <p class="process_one">
            <span class="jiantou" style="display:block;"></span>
            <span class="jiantou2"></span>
            <span class="process_three">{{report.webSendTimeMin}}/{{report.webSendTimeMax}}ms</span>
            <span class="process_four">{{report.webEchoTimeMin}}/{{report.webEchoTimeMax}}ms</span>
            <!-- <span class="process_three">{{report.webSendTimeMin}}/{{report.webSendTimeMax}}ms</span>
            <span class="process_four">{{report.webEchoTimeMin}}/{{report.webEchoTimeMax}}ms</span> -->
          </p>
        </div>
        <div class="process">
          <span class="process_span">wallet</span>
          <span class="process_top">{{report.walletDealWithTimeFor}}ms</span>
          <span class="process_bottom">{{report.walletDealWithTimeRev}}ms</span>
          <!-- <span class="process_top">{{report.walletDealWithTimeFor}}ms</span>
          <span class="process_bottom">{{report.walletDealWithTimeRev}}ms</span> -->
          <p class="process_one">
            <span class="jiantou" style="display:block;"></span>
            <span class="jiantou2"></span>
            <span class="process_three">{{report.walletSendTimeMin}}/{{report.walletSendTimeMax}}ms</span>
            <span class="process_four">{{report.walletEchoTimeMin}}/{{report.walletEchoTimeMin}}ms</span>
            <!-- <span class="process_three">{{report.walletSendTimeMin}}/{{report.walletSendTimeMax}}ms</span>
            <span class="process_four">{{report.walletEchoTimeMin}}/{{report.walletEchoTimeMin}}ms</span> -->
          </p>
        </div>
        <div class="process">
          <span class="process_span">node</span>
            <span class="process_top">{{report.nodeDealWithTimeFor}}ms</span>
            <span class="process_bottom">{{report.nodeDealWithTimeRev}}ms</span>
          <!-- <span class="process_top">{{report.nodeDealWithTimeFor}}ms</span>
          <span class="process_bottom">{{report.nodeDealWithTimeRev}}ms</span> -->
          <p class="process_one">
            <span class="jiantou" style="display:block;"></span>
            <span class="jiantou2"></span>
            <span class="process_three">{{report.nodeSendTimeMin}}/{{report.nodeSendTimeMax}}ms</span>
            <span class="process_four">{{report.nodeEchoTimeMin}}/{{report.nodeEchoTimeMax}}ms</span>
            <!-- <span class="process_three">{{report.nodeSendTimeMin}}/{{report.nodeSendTimeMax}}ms</span>
            <span class="process_four">{{report.nodeEchoTimeMin}}/{{report.nodeEchoTimeMax}}ms</span> -->
          </p>
        </div>
        <div class="process">
          <span class="process_span">center</span>
          <span class="process_top">{{report.centerDealWithTimeFor}}ms</span>
          <span class="process_bottom">{{report.centerDealWithTimeRev}}ms</span>
          <!-- <span class="process_top">{{report.centerDealWithTimeFor}}ms</span>
          <span class="process_bottom">{{report.centerDealWithTimeRev}}ms</span> -->
        </div>

        <div class="type_lie">
          <p>
            <span class="yuan1"></span><span>&ensp;发出交易时间</span>
            <br>
            <span class="yuan2"></span><span>&ensp;返回交易时间</span>
          </p>
        </div>
        <br><br><br><br>
        <p class="font_fam_content"><span class="font_fam">03</span>
          <span style="vertical-align:top;">&ensp;记录错误信息</span>
          <span @click="divShow4">
            <i class="el-icon-question"></i>
          </span>
        </p>
        <div class="divHide4" style="background-color:#ededed;width:98%;height:auto;display:none;padding: 10px;">
            （1）交易未上链处理路径：首先查询出未上链的traceId，然后对于每个traceId,查询经过了几个节点，对于每个节点的数据，判断此节点属于哪种类型，并拼接成处理路径。<br/>
            （2）日志错误信息：查询某时间段内，错误日志的信息。（logs）<br/>
        </div>
        <br>
        <div class="">
          <p style="color:#313131;font-size:18px;cursor:pointer;">交易未上链处理路径</p>
          <!-- 如果数组长度大于四，只显示前四个 -->
          <div class="content_log show1" v-if="this.logLists.length >4">
            <div v-for="(item,index) in logLists.slice(0,4)" :key="index">
              <p>
                {{ index+1 }} : {{item}}
              </p>
            </div>
            <span class="content_aaa" @click="seeMore1()">查看更多</span>
          </div>
          <!-- 否则显示全部，长度小于四个 -->
          <div class="content_log" v-else>
            <div v-for="(item,index) in logLists" :key="index">
              <p>
                {{ index+1 }} : {{item}}
              </p>
            </div>
          </div>
          <!-- 数组的全部元素 -->
           <div class="content_log show2" style="display:none">
            <div v-for="(item,index) in logLists" :key="index">
              <p>
                {{ index+1 }} : {{item}}
              </p>
            </div>
             <span class="content_aaa" @click="seeSq1()">收起</span>
          </div>

          </div>
        </div>
        <br>
        <div class="">
          <div class="logInformation">
            <p style="color:#313131;font-size:18px;cursor:pointer;">日志错误信息</p>
            <el-button class="export" type="primary" @click="downloadLog">下载日志</el-button>
          </div>
          <!-- 如果数组长度大于四，只显示前四个 -->
          <div class="content_log show3" v-if="this.logLists2.length >4">
            <div v-for="(item,index) in logLists2.slice(0,4)" :key="index">
              <p>
                {{ index+1 }} : {{item}}
              </p>
            </div>
            <span class="content_aaa" @click="seeMore2()">查看更多</span>
          </div>
          <!-- 否则显示全部，长度小于四个 -->
          <div class="content_log" v-else>
            <div v-for="(item,index) in logLists2" :key="index">
              <p>
                {{ index+1 }} : {{item}}
              </p>
            </div>
          </div>
          <!-- 数组的全部元素 -->
           <div class="content_log show4" style="display:none">
            <div v-for="(item,index) in logLists2" :key="index">
              <p>
                {{ index+1 }} : {{item}}
              </p>
            </div>
             <span class="content_aaa" @click="seeSq2()">收起</span>
          </div>

        </div>
        <br><br><br><br>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import echarts from "echarts";
  import $ from 'jquery';
  import html2canvas from 'html2canvas';
  // import Pdfjs from 'pdfjs';
  export default {
    name: "problemxq",
    data() {
      return{
        zoneLists:[],
        blockingTime:'',
        dataURL:'',
        index:'0',
        lists:[{},{}],
        // item_name:true,
        // item_id:false,
        logs:[
          // {
          //   id:'0',
          //   text:'eryjerjterjtkehgdfjkghfjkghdfjkghdfjkghdfjkghfjkhdfjkgdfhjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdjkghdfjkghdfjkghdfjkghdfjkghdjkhgjkhgjhgdfjkghdfjkghdfjkghdfjhgjkdfhgjkdfhgjkdfhgdfjk'
          // },
          // {
          //   id:'0',
          //   text:'eryjerjterjtkehgdfjkghfjkghdfjkghdfjkghdfjkghfjkhdfjkgdfhjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdfjkghdjkghdfjkghdfjkghdfjkghdfjkghdjkhgjkhgjhgdfjkghdfjkghdfjkghdfjhgjkdfhgjkdfhgjkdfhgdfjk'
          // }
        ],
        logLists:[],
        logLists2:[],
        report:'',
        outNumList:'',
        webSendTxNum:'',
        walletSendTxNum:'',
        nodeSendTxNum:'',
        webEchoTxNum:'',
        walletEchoTxNum:'',
        nodeEchoTxNum:'',
        digitalAbstract:''
      }
    },
    mounted(){
      // this.getEcharts();
      this.getProblem("0");
      // for(var i in this.logs){
      //   this.logs[i].item_name = true;
      //   this.logs[i].item_id = false;
      //   this.logs[i].item_name2 = true;
      //   this.logs[i].item_id2 = false;
      // }
      // this.logLists = this.logs;
      // this.logLists2 = this.logs;
      // console.log(this.logLists)
    },
    watch:{

    },
    methods: {
      printContent(e){
        html2canvas(this.$refs.faultTree, {
           backgroundColor: '#FFF'
         }).then((canvas) => {
           var imgUri = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream"); // 获取生成的图片的url
           window.location.href= imgUri; // 下载图片
         })
        // html2canvas(this.$refs.faultTree.then(function(canvas) {
	      //    var imgUri = canvas.toDataURL("image/png"); // 获取生成的图片的url
	      //    window.location.href= imgUri; // 下载图片
        // }))
         // var image = new Image();
         // // document.getElementsByTagName("canvas")[0];
         // console.log(document.getElementsByTagName("canvas")[0]);
         // image.src = document.getElementsByTagName("canvas")[0].toDataURL("image/png");
         // $("#canvasT").attr('src',image.src)
         // let subOutputRankPrint = document.getElementById('table');
         // console.log(subOutputRankPrint.innerHTML);
         //  let newContent =subOutputRankPrint.innerHTML;
         //  let oldContent = document.body.innerHTML;
         //  try {
         //    print.portrait = true;
         //  } catch(e) {
         //    this.$message('请手动调整打印方向');
         //  }
         //  document.body.innerHTML = newContent;
         //  window.print();
         //  window.location.reload();
         //  document.body.innerHTML = oldContent;
         //  return false;
      },
      getProblem(eva){
        let params = {
            reportid:this.$route.query.reportid
        };
        params = this.$qs.stringify(params,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/report/getReport',
            data:params
        }).then((res)=>{
            console.log(res.data);
            this.zoneLists = res.data.result;
            if(res.data.result[eva].outNumList != "")
            {
              this.outNumList = JSON.parse(res.data.result[eva].outNumList);
            }else{
              this.outNumList = "";
            }
            if(res.data.result[eva].blockingTime != ""){
              this.blockingTime = JSON.parse(res.data.result[eva].blockingTime);
              console.log(this.blockingTime);
            }else{
              this.blockingTime = "";
            }
            if(res.data.result[eva].webSendTxNum != ""){
              this.webSendTxNum = JSON.parse(res.data.result[eva].webSendTxNum);
            }else{
              this.webSendTxNum = "";
            }
            if(res.data.result[eva].walletSendTxNum != ""){
              this.walletSendTxNum = JSON.parse(res.data.result[eva].walletSendTxNum);
            }else{
              this.walletSendTxNum = "";
            }
            if(res.data.result[eva].nodeSendTxNum != ""){
              this.nodeSendTxNum = JSON.parse(res.data.result[eva].nodeSendTxNum);
            }else{
              this.nodeSendTxNum = "";
            }
            if(res.data.result[eva].webEchoTxNum != ""){
              this.webEchoTxNum = JSON.parse(res.data.result[eva].webEchoTxNum);
            }else{
              this.webEchoTxNum = "";
            }
            if(res.data.result[eva].walletEchoTxNum != ""){
              this.walletEchoTxNum = JSON.parse(res.data.result[eva].walletEchoTxNum);
            }else{
              this.walletEchoTxNum = "";
            }
            if(res.data.result[eva].nodeEchoTxNum != ""){
              this.nodeEchoTxNum = JSON.parse(res.data.result[eva].nodeEchoTxNum);
            }else{
              this.nodeEchoTxNum = "";
            }
            if(this.zoneLists[eva].digitalAbstract != ""){
              this.digitalAbstract = this.zoneLists[eva].digitalAbstract;
            }else{
              this.digitalAbstract = "";
            }
            console.log(this.digitalAbstract);
            this.report = res.data.result[eva];
            this.logLists = res.data.result[eva].notOnchainPath.split(";");
            this.logLists.pop();
            if(this.zoneLists[eva].errorList != ""){
              this.logLists2 = this.zoneLists[eva].errorList.split(",");
            }else{
              this.logLists2 = "";
            }
            // this.logLists2 = this.zoneLists[eva].errorList.split(",");
            this.getEcharts();
            this.getEcharts2();
            this.getEcharts3();
        })
      },
      // seeMore(eva){
      //   this.$forceUpdate();
      //   this.$set(this.logLists[eva],'item_name',false);
      //   this.$set(this.logLists[eva],'item_id',true)
      // },
      seeMore1(){
        $('.show1').css("display","none");
        $('.show2').css("display","block");
      },
      seeSq1(){
        $('.show1').css("display","block");
        $('.show2').css("display","none");
      },
      seeMore2(){
        $('.show3').css("display","none");
        $('.show4').css("display","block");
      },
      seeSq2(){
        $('.show3').css("display","block");
        $('.show4').css("display","none");
      },
      // seeMore2(eva){
      //   this.$forceUpdate();
      //   this.$set(this.logLists2[eva],"item_name2",false);
      //   this.$set(this.logLists2[eva],"item_id2",true);
      // },
      // seeSq2(eva){
      //   this.$forceUpdate();
      //   this.$set(this.logLists2[eva],"item_name2",true);
      //   this.$set(this.logLists2[eva],"item_id2",false);
      // },
      partition(eva){
        this.index = eva;
        // this.getProblem(eva);
        if(this.zoneLists[eva].outNumList != ""){
          this.outNumList = JSON.parse(this.zoneLists[eva].outNumList);
        }else{
          this.outNumList = "";
        }

        if(this.zoneLists[eva].blockingTime != ""){
          this.blockingTime = JSON.parse(this.zoneLists[eva].blockingTime);
        }else{
          this.blockingTime = "";
        }
        if(this.zoneLists[eva].webSendTxNum != ""){
          this.webSendTxNum = JSON.parse(this.zoneLists[eva].webSendTxNum);
        }else{
          this.webSendTxNum = "";
        }
        if(this.zoneLists[eva].walletSendTxNum != ""){
          this.walletSendTxNum = JSON.parse(this.zoneLists[eva].walletSendTxNum);
        }else{
          this.walletSendTxNum = "";
        }
        if(this.zoneLists[eva].nodeSendTxNum != ""){
          this.nodeSendTxNum = JSON.parse(this.zoneLists[eva].nodeSendTxNum);
        }else{
          this.nodeSendTxNum = "";
        }
        if(this.zoneLists[eva].webEchoTxNum != ""){
          this.webEchoTxNum = JSON.parse(this.zoneLists[eva].webEchoTxNum);
        }else{
          this.webEchoTxNum = "";
        }
        if(this.zoneLists[eva].walletEchoTxNum != ""){
          this.walletEchoTxNum = JSON.parse(this.zoneLists[eva].walletEchoTxNum);
        }else{
          this.walletEchoTxNum = "";
        }
        if(this.zoneLists[eva].nodeEchoTxNum != ""){
          this.nodeEchoTxNum = JSON.parse(this.zoneLists[eva].nodeEchoTxNum);
        }else{
          this.nodeEchoTxNum = "";
        }
        if(this.zoneLists[eva].digitalAbstract != ""){
          this.digitalAbstract = this.zoneLists[eva].digitalAbstract;
        }else{
          this.digitalAbstract = "";
        }
        this.report = this.zoneLists[eva];
        this.logLists = this.zoneLists[eva].notOnchainPath.split(";");
        this.logLists.pop();
        if(this.zoneLists[eva].errorList != ""){
          this.logLists2 = this.zoneLists[eva].errorList.split(",");
        }else{
          this.logLists2 = "";
        }
        // this.logLists2 = this.zoneLists[eva].errorList.split(",");
        this.getEcharts();
        this.getEcharts2();
        this.getEcharts3();
      },
      getEcharts(){
        var params = {

        };
        params = this.$qs.stringify(params,{ indices: false });
        var arr = [];
        var that = this;
        // this.axios({
        //     method:'post',
        //     url:window.API_HOST+'/monitor/selectOneSystemMonInfo',
        //     data:params
        // }).then((res)=>{
            // formatDate(1555133179128)
            function formatDate(eva) {
              var now = new Date(eva);
              var year=now.getFullYear();
              var month=now.getMonth()+1;
              var date=now.getDate();
              var hour=now.getHours();
              var minute=now.getMinutes();
              var second=now.getSeconds();
              return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
            }
            for(var i = 0;i<this.blockingTime.blockingTime.length;i++){
              formatDate(Number(this.blockingTime.blockingTime[i].time));  
              arr.unshift([formatDate(Number(this.blockingTime.blockingTime[i].time)),this.blockingTime.blockingTime[i].value])
            }
            var myChartCity = echarts.init(document.getElementById('haderPaint'));
            var data = arr;
            var dateList = data.map(function (item) {
                return item[0];
            });
            var valueList = data.map(function (item) {
                return item[1];
            });
            var that = this;
            myChartCity.setOption ({
              // Make gradient line here
                visualMap: [{
                    show: false,
                    type: 'continuous',
                    seriesIndex: 0,
                    min: 0,
                    max: 400
                }],
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                title: [{
                    left: 'center',
                    text: that.titleText
                }],
                tooltip: {
                    trigger: 'axis',
                    formatter:function(params)//数据格式
                    {
                      var relVal = params[0].name+"<br/>";
                      relVal +="<span style='color:#4D74FF;font-size:20px;'>● </span>";
                      relVal += params[0].data;
                      return relVal;
                    }
                },
                legend: {
                    data:['流量'],
                    x: 'left'
                },
                xAxis: [{
                    data: dateList,
                    boundaryGap:false,
                  }],
                yAxis: [{
                    splitLine: {show: false},
                    name : '(毫秒/单位)',
                }],
                series: [{
                    type: 'line',
                    showSymbol: false,
                    data: valueList,
                    itemStyle : {
                        normal : {
                            lineStyle:{
                                color:'#F19149'
                            }
                        }
                    },
                }]

            });
            setTimeout(function() {
              // window.addEventListener("resize",function(){
                  myChartCity.resize();
              // });
            },200)
            window.addEventListener("resize",function(){
                myChartCity.resize();
            });
        // })
      },
      getEcharts2(){
        var params = {

        };
        params = this.$qs.stringify(params,{ indices: false });
        var arr = [];
        var that = this;
        function formatDate(eva) {
          var now = new Date(eva);
          var year=now.getFullYear();
          var month=now.getMonth()+1;
          var date=now.getDate();
          var hour=now.getHours();
          var minute=now.getMinutes();
          var second=now.getSeconds();
          return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
        }
        for(var i = 0;i<this.outNumList.outNumList.length;i++){
          formatDate(Number(this.outNumList.outNumList[i].time));
          //时间顺序由push -> unshift
          arr.push([formatDate(Number(this.outNumList.outNumList[i].time)),this.outNumList.outNumList[i].value,this.outNumList.outNumList[i].height])
        }
        console.log(this.outNumList);
            var myChartCity = echarts.init(document.getElementById('haderPaint2'));
            var data = arr;
            var dateList = data.map(function (item) {
                return item[0];
            });
            var valueList = data.map(function (item) {
                return item[1];
            });
            var heightList = data.map(function (item) {
                return item[2];
            });
            var that = this;
            myChartCity.setOption ({
              // Make gradient line here
                visualMap: [{
                    show: false,
                    type: 'continuous',
                    seriesIndex: 0,
                    min: 0,
                    max: 400
                }],
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                title: [{
                    left: 'center',
                    text: that.titleText
                }],
                tooltip: {
                    trigger: 'axis',
                    formatter:function(params)//数据格式
                    {
                      var relVal = params[0].name+"<br/>";
                      relVal +="数量："+"<span style='color:#4D74FF;font-size:20px;'>● </span>";
                      relVal += params[0].value+"<br/>";
                      for(var i = 0;i<data.length;i++){
                          if(params[0].name == data[i][0]){
                            relVal +="高度："+"<span style='color:#4D74FF;font-size:20px;'>● </span>";
                            relVal += data[i][2]+"<br/>";
                          }
                      }
                      return relVal;
                    },
                },
                legend: {
                    data:['流量'],
                    x: 'left'
                },
                xAxis: [{
                    data: dateList,
                    boundaryGap:false
                  }],
                yAxis: [{
                    splitLine: {show: false},
                    name : '(数量/单位)',
                }],
                series: [{
                    type: 'line',
                    showSymbol: false,
                    data: valueList,
                    itemStyle : {
                        normal : {
                            lineStyle:{
                                color:'#009896'
                            }
                        }
                    },
                },
                ]

            });
            setTimeout(function() {
              // window.addEventListener("resize",function(){
                  myChartCity.resize();
              // });
            },200)
            window.addEventListener("resize",function(){
                myChartCity.resize();
            });
        // })
      },
      getEcharts3(){
        var params = {

        };
        params = this.$qs.stringify(params,{ indices: false });
        var arr = [];
        var arr2 = [];
        var arr3 = [];
        var arr4 = [];
        var arr5 = [];
        var arr6 = [];
        var arr7 = [];
        var that = this;
        // this.axios({
        //     method:'post',
        //     url:window.API_HOST+'/monitor/selectOneSystemMonInfo',
        //     data:params
        // }).then((res)=>{
            // this.tableData = res.data;
            function formatDate(eva) {
              var now = new Date(eva);
              var year=now.getFullYear();
              var month=now.getMonth()+1;
              var date=now.getDate();
              var hour=now.getHours();
              var minute=now.getMinutes();
              var second=now.getSeconds();
              return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
            }
            for(let i in this.webSendTxNum.txNum){
              arr.unshift(this.webSendTxNum.txNum[i].value);
              arr7.unshift(formatDate(this.webSendTxNum.txNum[i].time));
            }
            console.log(arr7);
            //时间顺序由push -> unshift
            for(let i in this.walletSendTxNum.txNum){
              arr2.unshift(this.walletSendTxNum.txNum[i].value)
            }
            for(let i in this.nodeSendTxNum.txNum){
              arr3.unshift(this.nodeSendTxNum.txNum[i].value)
            }
            for(let i in this.webEchoTxNum.txNum){
              arr4.unshift(this.webEchoTxNum.txNum[i].value)
            }
            for(let i in this.walletEchoTxNum.txNum){
              arr5.unshift(this.walletEchoTxNum.txNum[i].value)
            }
            for(let i in this.nodeEchoTxNum.txNum){
              arr6.unshift(this.nodeEchoTxNum.txNum[i].value)
            }
            console.log(arr,arr2,arr3,arr4,arr5,arr6);
            var myChartCity = echarts.init(document.getElementById('haderPaint3'));
            var that = this;
            myChartCity.setOption ({
              tooltip: {
                  trigger: 'axis'
              },
              grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
              },
              toolbox: {
                  feature: {
                      saveAsImage: {}
                  }
              },
              xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  data: arr7
              },
              yAxis: {
                  type: 'value',
                  name : '(数量/单位)',
              },
              series: [
                  {
                      name:'web->wallet',
                      symbol:'none',
                      smooth:true,
                      type:'line',
                      stack: '总量',
                      color:'#7D99FE',
                      data:arr
                  },
                  {
                      name:'wallet->node',
                      symbol:'none',
                      smooth:true,
                      type:'line',
                      stack: '总量',
                      color:'#3657CF',
                      data:arr2
                  },
                  {
                      name:'node->center',
                      symbol:'none',
                      smooth:true,
                      type:'line',
                      stack: '总量',
                      color:'#0028B7',
                      data:arr3
                  },
                  // {
                  //     name:'center->node',
                  //     symbol:'none',
                  //     smooth:true,
                  //     type:'line',
                  //     stack: '总量',
                  //     color:'#F8785A',
                  //     data:arr4
                  // },
                  {
                      name:'node->wallet',
                      symbol:'none',
                      smooth:true,
                      type:'line',
                      stack: '总量',
                      color:'#E54E2B',
                      data:arr5
                  },
                  {
                      name:'wallet->web',
                      symbol:'none',
                      smooth:true,
                      type:'line',
                      stack: '总量',
                      color:'#BC2300',
                      data:arr6
                  }
              ]
            });
            setTimeout(function(){
              // window.addEventListener("resize",function(){
                  myChartCity.resize();
              // });
            },200)
            window.addEventListener("resize",function(){
                myChartCity.resize();
            });
        // })
      },
       divShow1(){
          if($('.divHide1').css("display") == 'none'){
            $('.divHide1').show();
          }
          else{
            $('.divHide1').hide();
          }
        },
        divShow2(){
          if($('.divHide2').css("display") == 'none'){
            $('.divHide2').show();
          }
          else{
            $('.divHide2').hide();
          }
        },
        divShow3(){
          if($('.divHide3').css("display") == 'none'){
            $('.divHide3').show();
          }
          else{
            $('.divHide3').hide();
          }
        },
        divShow4(){
          if($('.divHide4').css("display") == 'none'){
            $('.divHide4').show();
          }
          else{
            $('.divHide4').hide();
          }
        },
        divShowPic1(){
          if($('.divHidePic1').css("display") == 'none'){
            $('.divHidePic1').show();
            $('#haderPaint').css("margin-top",'100px');
          }
          else{
            $('.divHidePic1').hide();
            $('#haderPaint').css("margin-top",'0');
          }
        },
        divShowPic2(){
          if($('.divHidePic2').css("display") == 'none'){
            $('.divHidePic2').show();
            $('#haderPaint2').css("margin-top",'100px');
          }
          else{
            $('.divHidePic2').hide();
            $('#haderPaint2').css("margin-top",'0');
          }
        },
        downloadLog(){
          let params = {
            digitalAbstract:this.digitalAbstract,
          }
          params = this.$qs.stringify(params,{ indices: false });
          this.axios({
          method:'post',
          url:window.API_HOST+'/report/errorLogDowland',
          data:params,
          responseType: 'blob',
      }).then((res)=>{
          var blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=utf-8'});
          var contentDisposition = res.headers['content-disposition']; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          var patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          var result = patt.exec(contentDisposition);
          var filename = result[1];
          var downloadElement = document.createElement('a');
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          var reg = /^["](.*)["]$/g;
          downloadElement.style.display = 'none';
          downloadElement.href = href;
          downloadElement.download = decodeURI(filename.replace(reg,"$1")); //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
      }
    },
  };
</script>
<style lang="scss" scoped>
@import "../../assets/font/font.css";
.el-tooltip__popper{
    position: absolute;
    border-radius: 4px;
    padding: 10px;
    z-index: 2000;
    font-size: 12px;
    line-height: 1.2;
    min-width: 10px;
}
.el-tooltip__popper.is-dark {
    background: #303133;
    color: #fff;
}
.show{
  display: inline-block;
}
.hide{
  display: none;
}
.content_log{
  margin-top: 10px;
  background: #F3F3F3;
  white-space: wrap;
  word-break: break-all;
  margin-right: 3%;
  padding: 15px 10px;
  p{
    margin-top: 10px;
    
  }
}
.content_aaa{
    color: #4E73FF;
    cursor: pointer;
    margin: 4px;
}
.web_cell_a{background: #7D99FE !important;}
.web_cell_b{background: #3657CF !important;}
.web_cell_c{background: #0028B7 !important;}
.web_cell_d{background: #F8785A !important;}
.web_cell_e{background: #E54E2B !important;}
.web_cell_f{background: #BC2300 !important;}
.jiantou4{
  width: 30px;
  display: inline-block;
  height: 1px;
  background: #333;
  vertical-align: super;
  position: relative;
}
.jiantou4::before{
  content: '';
  position: absolute;
  display: inline-block;
  width: 1px;
  top: -8px;
  height: 10px;
  margin-left: 2px;
  background: #000;
  transform: rotate(45deg);
}
.jiantou4::after{
  content: '';
  position: absolute;
  display: inline-block;
  width: 1px;
  top: -1px;
  height: 10px;
  margin-left: 2px;
  background: #000;
  transform: rotate(-45deg);
}
.jiantou3{
  width: 30px;
  display: inline-block;
  height: 1px;
  background: #333;
  vertical-align: super;
  position: relative;
}
.jiantou3::before{
  content: '';
  position: absolute;
  display: inline-block;
  width: 1px;
  top: -1px;
  height: 10px;
  margin-left: 26px;
  background: #000;
  transform: rotate(45deg);
}
.jiantou3::after{
  content: '';
  position: absolute;
  display: inline-block;
  width: 1px;
  top: -8px;
  height: 10px;
  margin-left: 26px;
  background: #000;
  transform: rotate(-45deg);
}
.lixiang_type_num{
  display: flex;
  -webkit-display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .web_cell{
    display: inline-block;
    width: 50px;
  }
  li{
    color: #060606;
    font-size: 14px;
    margin-top: 10px;
    width: calc(100%/4);
    color: #414141;
    cursor: pointer;
    &:nth-child(3){
      width:50%;
    }
    &:nth-child(6){
      width:50%;
    }
    span:first-child{
      display: inline-block;
      vertical-align: middle;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      -webkit-border-radius: 50%;
      background: #7D99FE;
    }
  }
}
.unit_echarts{
  position: relative;
  p{
    position: absolute;
    color:#414141;
    top: 15px;
    right: 3%;
    span{
      display: inline-block;
      width: 14px;
      height: 14px;
      background: #F19149;
      border-radius: 50%;
      -webkit-border-radius: 50%;
    }
  }
}
#haderPaint,#haderPaint2,#haderPaint3{
  height: 480px;
}
#haderPaint2>div{
  width: 100% !important;
}
#haderPaint3>div{
  width: 100% !important;
}
.type_lie{
  display: inline-block;
  position: relative;
  color: #727272;
  top: 10px;
  left: -100px;
  .yuan1{
    display: inline-block;
    width: 14px;
    height: 14px;
    background: #4E73FF;
    border-radius: 50%;
    -webkit-border-radius: 50%;
  }
  .yuan2{
    display: inline-block;
    width: 14px;
    height: 14px;
    background: #313131;
    border-radius: 50%;
    -webkit-border-radius: 50%;
  }
}

.process{
  position: relative;
  display: inline-block;
  width: 15%;
  .process_top{
    position: absolute;
    top: -22px;
    font-size: 16px;
    left: 23px;
    color: #4E73FF;
    cursor: pointer;
  }
  .process_bottom{
    position: absolute;
    top: 40px;
    font-size: 16px;
    left: 23px;
    cursor: pointer;
  }
  .process_one{
    display: inline-block;
    position: relative;
    top: 5px;
    margin-left: 12px;
    width: 50%;
  }
  .process_four{
    position: absolute;
    top: 15px;
    left: 12px;
    cursor: pointer;
  }
  .process_three{
    color: #4E73FF;
    position: absolute;
    top: -22px;
    left: 12px;
    cursor: pointer;
  }
  .process_span{
    display: inline-block;
    width: 80px;
    height: 40px;
    background: url("../../assets/images/back_radio.png") no-repeat;
    background-size: 100% 100%;
    text-align: center;
    line-height: 37px;
    font-size: 20px;
    color: #242424;
    // margin-right: 20px;
  }
}
.jiantou{
  width: 100%;
  display: inline-block;
  height: 2px;
  background: #333;
  vertical-align: middle;
  position: relative;
  background: #4E73FF;
}
.jiantou::after{
  content: '';
  position: absolute;
  display: inline-block;
  width: 2px;
  top: -11px;
  left: 36px;
  height: 13px;
  margin-left: 79px;
  background: #000;
  transform: rotate(-45deg);
  background: #4E73FF;
}
.jiantou2{
  width: 100%;
  display: inline-block;
  height: 2px;
  background: #333;
  vertical-align: middle;
  position: relative;

}
.jiantou2::after{
  content: '';
  position: absolute;
  display: inline-block;
  width: 2px;
  top: -1px;
  height: 13px;
  margin-left: 5px;
  background: #000;
  transform: rotate(135deg);
}

.lixiang_type{
  display: flex;
  -webkit-display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  li{
    color: #060606;
    font-size: 20px;
    margin-top: 10px;
    width: calc(100%/3);
    color: #486AFF;
    cursor: pointer;
    // &:nth-child(5){
    //   width:75%;
    // }
    span{
      display: inline-block;
      width: 180px;
      font-size: 18px;
      color: #060606;
    }
  }
}
.font_fam_content{
  font-size: 24px;
  color: #4E73FF;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.font_fam{
  font-family: 'dincond';
  font-size: 30px;
}
.isActive{
  background: #4E73FF;
  color: #FFF !important;
}
.content{
  margin-left: 3%;
  margin-top: 20px;

}
.content>span{
  display: inline-block;
  width: 113px;
  height: 40px;
  cursor: pointer;
  font-size: 20px;
  color: #4E73FF;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  border:1px solid #4E73FF;
  margin-right: 10px;
  text-align: center;
  line-height: 38px;
}
.title{
  background: url("../../assets/images/back_gr.png");
  background-size: 100% 100%;
  position: relative;
  width: 100%;
  height: 167px;
  color: #FFF;
  p:first-child{
    font-size:30px;
    padding: 48px 0 10px 3%;
  }
  p:last-child{
    padding-left: 3%;
  }
  .export{
      position: absolute;
      right: 32px;
      top:20px;
  }
}
.container{
  box-shadow: #B7C7FF 0px 0px 20px;
  min-height: 800px;
}
// #show1, #show2 , #show3, #show4{
//   display: block;
// }
// #hide1 , #hide2 , #hide3 , #hide4{
//   display: none;
// }
.el-icon-question:before {
    content: "\E634";
    font-size: 22px;
    color: #456ca1;
    cursor: pointer;
}
.logInformation{
    display: flex;
    justify-content: space-between;
    margin-right: 54px;
}
</style>
